export class MockStorage {
  storage: { [key: string]: string };
  constructor() {
    this.storage = {};
  }
  setItem(key: string, value: string) {
    this.storage[key] = value;
  }
  getItem(key: string) {
    return this.storage[key] || null;
  }
  removeItem(key: string) {
    delete this.storage[key];
  }
  key(index: number) {
    return Object.keys(this.storage).at(index) || null;
  }
  clear() {
    this.storage = {};
  }
}

// only used in _app component
export const storageAvailable = (type: string) => {
  try {
    const storage: Storage =
      type == 'localStorage' ? window?.localStorage : window?.sessionStorage;
    const key = '__storage_test__';
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};
